import { breakpoints } from 'config/breakpoints';
import { gridCssResponsiveVariables } from '../grid';
import { ratiosCssResponsiveVariables } from '../ratios';
import { spacingCssResponsiveVariables } from '../spacing';
import { transitionsCssResponsiveVariables } from '../transitions';
import { zIndexCssResponsiveVariables } from '../z-index';
import { type Theme } from './index';

// All statics here must use the --dark-- prefix so they are picked up in core-web App/Styles
// and exposed on :root for the data-theme switch. Unprefixed vars would be ignored.
const statics = {
    // UI
    '--dark--ui-primary': 'var(--color-base-off-white)',
    '--dark--ui-secondary': 'var(--color-opacity-off-white-70)',
    '--dark--ui-background': 'var(--color-base-charcoal)',
    '--dark--overlay-overlay-background': 'var(--color-opacity-light-beige-90)',
    '--dark--stroke-default': 'var(--color-opacity-off-white-30)',
    '--dark--stroke-hover': 'var(--color-opacity-off-white-70)',
    '--dark--stroke-active': 'var(--color-opacity-off-white-70)',
    '--dark--gradient-30': 'var(--color-opacity-charcoal-30)',
    '--dark--gradient-0': 'var(--color-opacity-charcoal-0)',
    '--dark--semantic-error': 'var(--color-semantic-red)',
    '--dark--semantic-warning': 'var(--color-semantic-yellow)',
    '--dark--semantic-success': 'var(--color-semantic-green)',
    '--dark--gradient-100': 'var(--color-base-charcoal)',
    '--dark--opacity-primary-50': 'var(--color-opacity-off-white-50)',
    '--dark--opacity-primary-30': 'var(--color-opacity-off-white-30)',
    '--dark--opacity-primary-15': 'var(--color-opacity-off-white-15)',
    '--dark--stroke-heavy': 'var(--color-opacity-off-white-50)',
    '--dark--stroke-full': 'var(--color-base-off-white)',
    '--dark--ui-secondary-aa': 'var(--color-opacity-off-white-70)',
    '--dark--ui-surface': 'var(--color-shade-light-charcoal)',
    '--dark--ui-primary-aa': 'var(--color-base-off-white)',

    // Button
    '--dark--button-primary-background': 'var(--color-base-brickwork-orange)',
    '--dark--button-secondary-background': 'var(--color-base-off-white)',
    '--dark--button-primary-text': 'var(--color-base-charcoal)',
    '--dark--button-secondary-text': 'var(--color-base-charcoal)',
    '--dark--button-tertiery-text': 'var(--color-base-off-white)',
    '--dark--button-tertiery-stroke': 'var(--color-opacity-off-white-30)',
    '--dark--button-primary-text-hover': 'var(--color-base-off-white)',
    '--dark--button-primary-text-active': 'var(--color-base-off-white)',
    '--dark--button-primary-text-disabled': 'var(--color-opacity-charcoal-50)',
    '--dark--button-primary-background-disabled': 'var(--color-base-brickwork-orange)',
    '--dark--button-secondary-text-hover': 'var(--color-shade-medium-orange)',
    '--dark--button-secondary-text-active': 'var(--color-shade-medium-orange)',
    '--dark--button-secondary-text-disabled': 'var(--color-opacity-charcoal-50)',
    '--dark--button-secondary-background-disabled': 'var(--color-shade-light-beige)',
    '--dark--button-tertiery-text-hover': 'var(--color-opacity-off-white-70)',
    '--dark--button-tertiery-text-active': 'var(--color-opacity-off-white-70)',
    '--dark--button-tertiery-text-disabled': 'var(--color-opacity-off-white-50)',
    '--dark--button-tertiery-stroke-hover': 'var(--color-opacity-off-white-30)',
    '--dark--button-tertiery-stroke-active': 'var(--color-opacity-off-white-30)',
    '--dark--button-tertiery-stroke-heavy': 'var(--color-opacity-off-white-50)',
    '--dark--button-tertiery-text-focus-outline': '2px solid var(--dark--button-tertiery-text)',
};

const responsives = {} as Theme['responsives'];
breakpoints.forEach((breakpoint) => {
    responsives[breakpoint.label] = {
        ...ratiosCssResponsiveVariables[breakpoint.label],
        ...gridCssResponsiveVariables[breakpoint.label],
        ...transitionsCssResponsiveVariables[breakpoint.label],
        ...zIndexCssResponsiveVariables[breakpoint.label],
        ...spacingCssResponsiveVariables[breakpoint.label],

        ...responsives[breakpoint.label],
    };
});

const theme: Theme = {
    statics,
    responsives,
};

export default theme;
